<template>
  <v-container fluid fill-height pa-0>
    <v-row>
      <v-col cols="12" md="8" offset-md="2">
        <v-card>
          <v-card-text class="pa-0">
            <v-alert type="error" class="error__alert">
              Cтраница не найдена
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {};
</script>
